// Schedule data for the RS4SD Workshop
export const scheduleDate = "Friday, November 14, 2025";

export const scheduleItems = [
    {
        time: "13:15-13:40",
        session: "Registration",
        type: "general"
    },
    {
        time: "13:40-13:45",
        session: "Welcome and Introduction",
        type: "general"
    },
    {
        time: null,
        session: "Keynote I: 30 min",
        type: "keynote-header"
    },
    {
        time: "13:45-14:15",
        session: "Opening Keynote: \"Future Health: Responsible Multi-modal Health Recommender Systems Powered by GenAI\"",
        subsession: "Prof. Amir. M. Rahmani (University of California, Irvine)",
        type: "keynote"
    },
    {
        time: null,
        session: "Session I: Presentation (6 papers: 60 min)",
        type: "session-header"
    },
    {
        time: "14:15-14:25",
        session: "Personalized Interpolation: Achieving Efficient Conversion Estimation with Flexible Optimization Windows",
        type: "paper"
    },
    {
        time: "14:25-14:35",
        session: "Towards Trustworthy LLM-Based Recommendation via Rationale Integration",
        type: "paper"
    },
    {
        time: "14:35-14:45",
        session: "Food-as-Medicine Recommender Systems: A Vision for Generative AI–Powered Grocery Guidance",
        type: "paper"
    },
    {
        time: "14:45-14:55",
        session: "SmartSustain Recommender System: Navigating Sustainability Trade-offs in Personalized City Trip Planning",
        type: "paper"
    },
    {
        time: "14:55-15:05",
        session: "Conversational Multi-Objective Recommendation in Collaborative Filtering",
        type: "paper"
    },
    {
        time: "14:05-15:15",
        session: "On Usefulness, Fidelity, and Generalizability of Post-hoc Explanation for Food Recommendation",
        type: "paper"
    },
    {
        time: null,
        session: "Coffee Break and Networking (30 min)",
        type: "break"
    },
    {
        time: null,
        session: "Keynote II: 30 min",
        type: "keynote-header"
    },
    {
        time: "15:45-16:15",
        session: "Second Keynote: \"Fairness and Sustainability in IR\" by Dr. Negar Arabzadeh (UC Berkeley)",
        type: "keynote"
    },
    {
        time: null,
        session: "Session II: Presentation (6 papers: 60 min)",
        type: "session-header"
    },
    {
        time: "16:15-16:25",
        session: "Efficient Recommendations via Graph Coarsening and Label Propagation",
        type: "paper"
    },
    {
        time: "16:25-16:35",
        session: "LSRec: A Lightweight Sequential Recommender with LLM Architecture",
        type: "paper"
    },
    {
        time: "16:35-16:45",
        session: "Health-Aware Food Recommendation Using a Deep Reinforcement Learning-based Ranking Optimization",
        type: "paper"
    },
    {
        time: "16:45-16:55",
        session: "Are We Fully Leveraging Semantic Identifiers? Insights from Error Analysis for Improving Generative Recommendation",
        type: "paper"
    },
    {
        time: "16:55-17:05",
        session: "CTMR: Cohort-Aware Transformer Multi-objective Ranker for Personalized, Debiased, and Diversity-Aware Product Search",
        type: "paper"
    },
    {
        time: "17:05-17:15",
        session: "My Travel Agent is a Multi-Agent System: An Adaptable Framework for Complex Domain-Specific Tasks",
        type: "paper"
    },
    {
        time: null,
        session: "Coffee Break and Networking (15 min)",
        type: "break"
    },
    {
        time: "17:30-17:45",
        session: "Closing Remarks, Wrap-up and Future Collaborations",
        type: "general"
    }
];
